import React, { FunctionComponent } from 'react';

import { Card } from 'components';
import { Text, Button, Heading } from 'components/chroma';

export type VehicleDetail = {
  name: string;
  model: string;
  transmission: string;
  registration: string;
};

const VehicleDetailCard: FunctionComponent<{
  vehicleDetails: VehicleDetail;
  onPrevious: () => void;
}> = ({ vehicleDetails, onPrevious }) => {
  const { name, model, transmission, registration } = vehicleDetails;

  return (
    <Card id={name} column>
      <Heading size={4} margin={{ bottom: 3 }}>
        {name}
      </Heading>
      <Text>
        <b>Model:</b> {model}
      </Text>
      <Text>
        <b>Transmission:</b> {transmission}
      </Text>
      <Text>
        <b>Registration:</b> {registration}
      </Text>
      <Button link onClick={onPrevious} margin={{ top: 3, bottom: 1 }}>
        No this is not the car
      </Button>
    </Card>
  );
};

export default VehicleDetailCard;
